import { render, staticRenderFns } from "./RandomChatIndex.vue?vue&type=template&id=2b7a0afb&"
import script from "./RandomChatIndex.vue?vue&type=script&lang=js&"
export * from "./RandomChatIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports